export default (person: User | undefined, investigator: boolean) => {
  if (!person) {
    return 'No user defined';
  }
  let name = person ? person.display_name ? `${person.display_name}` : `${person.first_name} ${person.last_name}` : '';

  if (investigator && person.external_id) {
    name += ` (#${person.external_id})`;
  }
  return name;
};
